import {
  core_v1_Rule,
  coreV1ReplaceRuleMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { setClientOfOrigin } from '@/utils/setClientOfOrigin';

export const useUpdateRule = () => {
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: ({ name, data }: { name: string; data: core_v1_Rule }) => {
      const dataWithClientOrigin = setClientOfOrigin(data);
      return coreV1ReplaceRuleMutation({
        ...defaultOptions(),
      }).mutationFn!({
        body: dataWithClientOrigin,
        path: { workspace, name },
      });
    },
  });
};
